import { render, staticRenderFns } from "./RatingScaleReferenceChart.vue?vue&type=template&id=5bc972a6&scoped=true&"
import script from "./RatingScaleReferenceChart.vue?vue&type=script&lang=ts&"
export * from "./RatingScaleReferenceChart.vue?vue&type=script&lang=ts&"
import style0 from "./RatingScaleReferenceChart.vue?vue&type=style&index=0&id=5bc972a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc972a6",
  null
  
)

export default component.exports